var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDiary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,16h2v7l-1,1H3L2,23V20H2V19H1V17H2V13H1V11H2V7H1V5H2V1L3,0H21l1,1V6H20V2H4V5H5V7H4v4H5v2H4v4H5v2H4v1H4v2H20ZM17,5H7V7H17ZM14.35,18.77l6.57-6.57L18.8,10.08l-6.57,6.57-1.08,2.5.7.7ZM22.29,8H20.88l-.71.71,2.12,2.12.71-.71V8.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiary);
export default __webpack_public_path__ + "static/1769707387/media/icon-diary.af15ffd78b30e642d696dcba14e04df2.svg";
export { ForwardRef as ReactComponent };